import { Injector } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { APIGestaCardService } from '../api/gestacard.service';
import { navigation } from 'app/config/fuse-config/navigation/navigation';
import { take } from 'rxjs/operators';
import { logger } from '../utils/console';

export function initializeApp(injector: Injector) {
  return (): Promise<any> => {
    return new Promise((resolve) => {

      let authService: AuthService;
      let fuseNavigationService: FuseNavigationService;
      let apiGestaCard: APIGestaCardService;

      try {
        // Lazy inject para evitar dependências circulares
        authService = injector.get(AuthService);
        fuseNavigationService = injector.get(FuseNavigationService);
        apiGestaCard = injector.get(APIGestaCardService);

        // Inicializa o AuthService (substitui lógica do construtor)
        if (authService && typeof authService.init === 'function') {
          authService.init();
        }
      } catch (error) {
        logger.error('APP_INITIALIZER: Erro ao injetar serviços', error);
        resolve(true);
        return;
      }

      // Verifica se há token de autenticação
      const token = localStorage.getItem('accessToken');
      
      if (!token) {
        // Se não houver token, resolve imediatamente
        // O menu será carregado após o login pelo subscriber no AppComponent
        resolve(true);
        return;
      }
      
      let resolved = false;
      const safeResolve = () => {
        if (!resolved) {
          resolved = true;
          resolve(true);
        }
      };

      const timeout = setTimeout(() => {
        safeResolve();
      }, 5000); // 5 segundos de timeout

      apiGestaCard.GetMenuOptionsObs().pipe(
        take(1) // Completa após primeira emissão
      ).subscribe(
        (menu) => {
          clearTimeout(timeout);
          try {
            // Verifica se já existe navegação configurada de forma segura
            let currentNav;
            try {
              currentNav = fuseNavigationService.getCurrentNavigation();
            } catch (e) {
              // Se getCurrentNavigation falhar, significa que não há navegação configurada
              currentNav = null;
            }
            
            if (currentNav !== menu.id) {
              fuseNavigationService.register(menu.id, [menu, navigation]);
              fuseNavigationService.setCurrentNavigation(menu.id || 'menu');
            }
            safeResolve();
          } catch (error) {
            logger.error('APP_INITIALIZER: Erro ao registrar menu:', error);
            safeResolve();
          }
        },
        (error) => {
          clearTimeout(timeout);
          logger.error('APP_INITIALIZER: Erro ao carregar menu:', error);
          safeResolve();
        }
      );
    });
  };
}
